import { AUTHORIZATION_SUPPORT_HEADER } from '@/auth/support'
import session from '@/auth/session'

const onRequestToken = (config = {}) => {
  const token = session.getToken()
  if (session.isSupportSession()) {
    config.headers['Authorization'] = AUTHORIZATION_SUPPORT_HEADER
    if (session.isApiLogin()) {
      config.headers['token'] = `Bearer ${token}`
    } else {
      config.headers['token'] = token
    }
  } else if (session.isExternalSession() || session.isApiLogin()) {
    config.headers['token'] = `Bearer ${token}`
  } else {
    config.headers['token'] = token
  }
  return config
}

/**
 * isPublic means does not need Authorization in headers
 */
const onRequestAuthorization = (config) => {
  if (config.headers['isPublic']) {
    delete config.headers['isPublic']
    return config
  }
  config.headers['Authorization'] = 'Bearer ' + session.getToken()
  return config
}

const onError = (error) => {
  return Promise.reject(error)
}

export default {
  onRequestToken,
  onRequestAuthorization,
  onError
}
